import React from 'react';
import WindowBody from './Window/WindowBody';
import WindowFooter from './Window/WindowFooter';
import { UiButton } from './UiButton';
import { API_ENDPOINT } from './Core/Grid/gridConstants';

interface IframePreviewWindowProps {
    url: string;
    triggerClose: () => void;
}

export const IframePreviewWindow: React.FC<IframePreviewWindowProps> = ({ url, triggerClose }) => {
    const fullUrl = `${API_ENDPOINT}${url}`;

    return (
        <>
            <WindowBody noPadding>
                <iframe
                    src={fullUrl}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="Preview"
                />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" type="button" onClick={triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
};
